import CircularLoader from '@spotnana/pixel-react/dist/CircularLoader';
import { useTranslation } from 'react-i18next';

import { LoaderContainer } from '../../v2-components/flights/checkout/styles';

const Loader = (): JSX.Element => {
  const { t: tt } = useTranslation('WEB');
  return (
    <LoaderContainer aria-label={tt('Circular loader')}>
      <CircularLoader size={50} />
    </LoaderContainer>
  );
};

export default Loader;
